import cx from 'classnames';

interface Props extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  hasFocusRing?: boolean;
}

export const RadioDot = ({ hasFocusRing = true, className, ...props }: Props) => {
  return (
    <input
      {...props}
      type="radio"
      className={cx(
        'relative size-4 shrink-0 appearance-none shadow-[inset_0_0_0_3px_white] transition-colors',
        'text-neutral-80 checked:text-neutral-20 hover:text-neutral-40 disabled:text-neutral-90',
        'bg-white checked:bg-current checked:disabled:bg-neutral-80',
        'cursor-pointer disabled:cursor-not-allowed',
        'rounded-full border border-solid border-current outline-none',
        {
          'focus-visible:focus-outline': hasFocusRing,
        },
        className,
      )}
    />
  );
};
